import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { TimeAndMaterialItemForm } from './time-and-material-item.form';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

interface CreateBuildingFloorButtonProps {
  projectID: number;
  onUnitCreated: (data: any) => void;
  syncWithDux: any
}

const validationSchema = Yup.object().shape({
  unitData: Yup.object().shape({
    unitName: Yup.string().required('Inspection title is required').max(9, 'Inspection cannot exceed 9 characters'),
    address: Yup.string().required('Address is required').max(31, 'Address cannot exceed 31 characters'),
    jobsite: Yup.string().required('Jobsite is required'),
  }),
});

export const CreateTimeAndMaterialButton = ({ projectID, syncWithDux, onUnitCreated }: CreateBuildingFloorButtonProps) => {
  const [newBuilding, setNewBuilding] = useState<any>();

  const handleDialogClose = () => {
    setNewBuilding(undefined);
  };

  const handleAddBuildingFloor = () => {
    setNewBuilding({
      projectID,
      floorName: '',
      unitData: {
        // createWO: false,
        syncWithDUX: false,
        buildingPermit: ''
      }
    });
  };

  const transformData = (data: any) => {
    return {
      unitName: data.unitName,
      jobNumber: data.jobNumber,
      address: data.address,
      squareFeet: !data?.squareFeet ? null : Number(data?.squareFeet),
      proctorResult: !data.proctorResult
        ? null
        : {
          proctorResultsID: data.proctorResult.proctorResultsID,
          unitID: 0,
          proctorFileName: data.proctorResult.proctorFileName,
        },
      // createWO: data.createWO,
      syncWithDUX: data.syncWithDUX,
      buildingPermit: data.buildingPermit
      // proctorResult:
      //   data.proctorResult?.map((result: any) => ({
      //     proctorResultsID: result.proctorResultsID,
      //     unitID: 0,
      //     proctorFileName: result.proctorFileName,
      //   })) || [],
    };
  };

  const formatSubmitData = (data: any) => {
    const transformedData = transformData(data.unitData);
    return { projectID, transformedData };
  };

  return (
    <>
      <GuardedComponent requiredPermissions={[UserPermissionName.ADD_UNIT]}>
        <Button
          className="btn btn-primary"
          variant="text"
          sx={{ p: 0, m: 0, mr: 1, mb: 3, ml: 3 }}
          onClick={handleAddBuildingFloor}
        >
          Add New
        </Button>
      </GuardedComponent>
      {newBuilding && (
        <SaveHookFormDialog
          title="CREATE INSPECTION TITLE"
          config={{
            saveConfig: projectsApiKeyStore.createLot(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onUnitCreated}
          formatSubmitdata={formatSubmitData}
          size="xs"
          yupSchema={validationSchema}
        >
          <TimeAndMaterialItemForm name="unitData" syncWithDux={syncWithDux} isEnabled={true} />
        </SaveHookFormDialog>
      )}
    </>
  );
};
